// WhatsApp Broadcast sayfalarının ortak arayüz parçaları (stiller: wsm.css, .wsm kapsamı).
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import cs from 'classnames';
import _ from 'lodash';
import './wsm.css';

export const COLORS = {
	primary: '#176D4A',
	navy: '#1C2430',
	slate: '#46525F',
	muted: '#5B6775',
	hint: '#7B8794',
	warn: '#9A5B00',
	danger: '#B42318',
	info: '#0B5FA5',
	purple: '#6B3FA0',
	waLink: '#0B7FD6',
	bar: { read: '#0B5FA5', delivered: '#2E9E6B', sent: '#B9D9C9', failed: '#F1D5D1' },
};

// Tek çizgili ikonlar (Feather stili); yol "M" harfinden bölünüp çizilir.
const ICON_PATHS = {
	send: 'M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z',
	layout: 'M3 3h18v18H3zM3 9h18M9 21V9',
	calendar: 'M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM16 2v4M8 2v4M3 10h18',
	clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 7v5l3 2',
	users: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
	user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
	userX: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M8.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM18 8l5 5M23 8l-5 5',
	userPlus: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M8.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM20 8v6M23 11h-6',
	search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.35-4.35',
	refresh: 'M21 12a9 9 0 1 1-2.6-6.4M21 3v6h-6',
	download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3',
	upload: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12',
	trash: 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6',
	check: 'M5 12l5 5L20 7',
	x: 'M18 6 6 18M6 6l12 12',
	chevronLeft: 'M15 18l-6-6 6-6',
	chevronRight: 'M9 18l6-6-6-6',
	plus: 'M12 5v14M5 12h14',
	edit: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z',
	link: 'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71',
	phone: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z',
	alert: 'M12 9v4M12 17h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z',
	info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 16v-4M12 8h.01',
	warn: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 8v4M12 16h.01',
	eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
	image: 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM8.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM21 15l-5-5L5 21',
	file: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM14 2v6h6M16 13H8M16 17H8M10 9H8',
	sheet: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM14 2v6h6M8 13h8M8 17h8M12 13v4',
	play: 'M5 3l14 9-14 9V3z',
	list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
	chart: 'M18 20V10M12 20V4M6 20v-6',
	chat: 'M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z',
	box: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16zM3.27 6.96 12 12.01l8.73-5.05M12 22.08V12',
	sparkles: 'M12 3l1.9 5.6L19.5 10l-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.4L12 3zM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15z',
	external: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3',
	reply: 'M9 17l-5-5 5-5M20 18v-2a4 4 0 0 0-4-4H4',
	smile: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01',
	tag: 'M20.59 13.41 12 22l-9-9V3h10l7.59 7.59a2 2 0 0 1 0 2.82zM7 7h.01',
	panelOpen: 'M3 3h18v18H3zM15 3v18M10 9l-3 3 3 3',
	panelClose: 'M3 3h18v18H3zM15 3v18M8 9l3 3-3 3',
	maximize: 'M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3',
	minimize: 'M8 3v3a2 2 0 0 1-2 2H3M21 8h-3a2 2 0 0 1-2-2V3M3 16h3a2 2 0 0 1 2 2v3M16 21v-3a2 2 0 0 1 2-2h3',
	window: 'M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 9h18',
};

export function Icon({ name, size = 16, color = 'currentColor', strokeWidth = 2, style }) {
	const d = ICON_PATHS[name] || ICON_PATHS.info;
	return (
		<svg
			className="wsm-ic"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
			style={style}
			aria-hidden="true"
		>
			{d
				.split('M')
				.filter(Boolean)
				.map((seg, i) => (
					<path key={i} d={'M' + seg} />
				))}
		</svg>
	);
}

export function WhatsAppLogo({ size = 40 }) {
	return (
		<div className="wsm-logo" style={{ width: size, height: size }}>
			<svg width={Math.round(size * 0.58)} height={Math.round(size * 0.58)} viewBox="0 0 24 24" aria-hidden="true">
				<path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5s-.7-1.6-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z" />
			</svg>
		</div>
	);
}

export function Spinner({ size = 16, light }) {
	return <span className={cs('wsm-spin', { light })} style={{ width: size, height: size }} />;
}

export function Loading({ text }) {
	return (
		<div className="wsm-loading">
			<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
				<Spinner size={30} />
			</div>
			{text || 'Yükleniyor…'}
		</div>
	);
}

export function Btn({ variant, size, icon, busy, block, children, className, type = 'button', disabled, ...rest }) {
	const light = !variant || variant === 'danger';
	return (
		<button type={type} className={cs('wsm-btn', variant, size, { block }, className)} disabled={disabled || busy} {...rest}>
			{busy ? <Spinner size={14} light={light} /> : icon ? <Icon name={icon} size={size === 'l' ? 18 : 16} /> : null}
			{children}
		</button>
	);
}

export function IconBtn({ icon, title, danger, active, size, className, ...rest }) {
	return (
		<button
			type="button"
			title={title}
			aria-label={title}
			className={cs('wsm-iconbtn', { danger, active }, className)}
			style={size ? { width: size, height: size } : undefined}
			{...rest}
		>
			<Icon name={icon} size={15} />
		</button>
	);
}

export function Card({ children, className, style, pad }) {
	return (
		<div className={cs('wsm-card', { 'wsm-card-pad': pad }, className)} style={style}>
			{children}
		</div>
	);
}

export function CardHead({ title, desc, right }) {
	return (
		<div className="wsm-card-head">
			<div style={{ minWidth: 0 }}>
				<h2 className="wsm-card-title">{title}</h2>
				{desc ? <div className="wsm-card-desc">{desc}</div> : null}
			</div>
			{right ? <div className="wsm-row">{right}</div> : null}
		</div>
	);
}

export function PageHead({ title, desc, right }) {
	return (
		<div className="wsm-head">
			<div style={{ minWidth: 0 }}>
				<h1 className="wsm-h1">{title}</h1>
				{desc ? <div className="wsm-desc">{desc}</div> : null}
			</div>
			{right ? <div className="wsm-row">{right}</div> : null}
		</div>
	);
}

export function Field({ label, required, hint, error, right, children, style }) {
	return (
		<div className="wsm-field" style={style}>
			{label || right ? (
				<div className="wsm-label-row">
					<label className="wsm-label">
						{label}
						{required ? <span className="wsm-req"> *</span> : null}
					</label>
					{right}
				</div>
			) : null}
			{children}
			{error ? <div className="wsm-error">{error}</div> : hint ? <div className="wsm-hint">{hint}</div> : null}
		</div>
	);
}

export function Input({ value, onChange, small, mono, className, ...rest }) {
	return (
		<input
			className={cs('wsm-input', { s: small, 'wsm-mono': mono }, className)}
			value={value === undefined || value === null ? '' : value}
			onChange={(e) => onChange && onChange(e.target.value, e)}
			{...rest}
		/>
	);
}

export function Textarea({ value, onChange, mono, rows = 4, className, ...rest }) {
	return (
		<textarea
			className={cs('wsm-textarea', { 'wsm-mono': mono }, className)}
			rows={rows}
			value={value === undefined || value === null ? '' : value}
			onChange={(e) => onChange && onChange(e.target.value, e)}
			{...rest}
		/>
	);
}

// options: [{ value, label, disabled }]. Native menü yerine her zaman aynı tasarımda panel (Combo);
// arama kutusu yalnızca uzun (8+) listelerde çıkar. onChange orijinal değeri döner.
export function Select({ value, onChange, options, small, auto, placeholder, disabled }) {
	return <Combo value={value} onChange={onChange} options={options} placeholder={placeholder} disabled={disabled} small={small} auto={auto} />;
}

// Aranabilir açılır liste: uzun listelerde tarayıcının ekranı kaplayan native menüsü yerine sabit yükseklikli panel.
// Panel body'ye portal ile açılır (tablo / kart overflow'u kesmesin); aşağıda yer yoksa yukarı açılır.
// options: [{ value, label, meta }]
export function Combo({ value, onChange, options, placeholder, searchPlaceholder, emptyText, disabled, small, auto, mono }) {
	const [open, setOpen] = useState(false);
	const [q, setQ] = useState('');
	const [pos, setPos] = useState(null);
	const ref = React.useRef(null);
	const popRef = React.useRef(null);
	const list = options || [];
	const searchable = list.length > 8;
	useEffect(() => {
		if (!open) return;
		const place = () => {
			const r = ref.current && ref.current.getBoundingClientRect();
			if (!r) return;
			const h = Math.min(320, (searchable ? 56 : 0) + list.length * 36 + 10);
			const below = window.innerHeight - r.bottom;
			const up = below < h + 12 && r.top > below;
			setPos({ left: r.left, width: Math.max(r.width, 220), top: up ? undefined : r.bottom + 4, bottom: up ? window.innerHeight - r.top + 4 : undefined });
		};
		place();
		const onDoc = (e) => {
			if (ref.current && ref.current.contains(e.target)) return;
			if (popRef.current && popRef.current.contains(e.target)) return;
			setOpen(false);
		};
		const onKey = (e) => e.key === 'Escape' && setOpen(false);
		// sayfa kayınca panel butondan kopmasın: kapat (panelin kendi kaydırması hariç)
		const onScroll = (e) => {
			if (popRef.current && popRef.current.contains(e.target)) return;
			setOpen(false);
		};
		document.addEventListener('mousedown', onDoc);
		window.addEventListener('keydown', onKey);
		window.addEventListener('resize', place);
		document.addEventListener('scroll', onScroll, true);
		return () => {
			document.removeEventListener('mousedown', onDoc);
			window.removeEventListener('keydown', onKey);
			window.removeEventListener('resize', place);
			document.removeEventListener('scroll', onScroll, true);
		};
	}, [open, searchable, list.length]);
	const cur = _.find(list, (o) => String(o.value) === String(value));
	const shown = _.filter(list, (o) => searchMatch(q, o.label, o.meta));
	return (
		<div className={cs('wsm-combo', { auto })} ref={ref}>
			<button
				type="button"
				className={cs('wsm-select', 'wsm-combo-btn', { open, s: small })}
				disabled={disabled}
				onClick={() => {
					setOpen(!open);
					setQ('');
				}}
			>
				{cur ? (
					<span className={cs('wsm-combo-cur', { mono })}>
						<strong>{cur.label}</strong>
						{cur.meta ? <span>{cur.meta}</span> : null}
					</span>
				) : (
					<span className="wsm-faint">{placeholder}</span>
				)}
			</button>
			{open && pos
				? ReactDOM.createPortal(
						<div className="wsm wsm-portal">
							<div className="wsm-combo-pop" ref={popRef} style={{ position: 'fixed', left: pos.left, width: pos.width, top: pos.top, bottom: pos.bottom, zIndex: 1050 }}>
								{searchable ? (
									<div className="wsm-combo-search">
										<SearchInput value={q} onChange={setQ} placeholder={searchPlaceholder || 'Ara…'} autoFocus />
									</div>
								) : null}
								<div className="wsm-combo-list">
									{shown.map((o) => (
										<button
											key={String(o.value)}
											type="button"
											disabled={o.disabled}
											className={cs('wsm-combo-item', { on: cur && cur.value === o.value, mono })}
											onClick={() => {
												onChange && onChange(o.value);
												setOpen(false);
											}}
										>
											<strong>{o.label}</strong>
											{o.meta ? <span>{o.meta}</span> : null}
											{cur && cur.value === o.value ? <Icon name="check" size={14} color={COLORS.primary} /> : null}
										</button>
									))}
									{!shown.length ? <div className="wsm-combo-empty">{emptyText || 'Sonuç yok'}</div> : null}
								</div>
							</div>
						</div>,
						document.body
				  )
				: null}
		</div>
	);
}

export function Check({ checked, onChange, label, disabled, title }) {
	return (
		<label className="wsm-check" title={title} style={disabled ? { opacity: 0.55, cursor: 'not-allowed' } : undefined}>
			<input type="checkbox" checked={!!checked} disabled={disabled} onChange={(e) => onChange && onChange(e.target.checked)} />
			{label}
		</label>
	);
}

export function SearchInput({ value, onChange, placeholder, style, autoFocus }) {
	return (
		<div className="wsm-search" style={style}>
			<Icon name="search" size={16} color={COLORS.hint} />
			<input className="wsm-input" type="search" value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} aria-label={placeholder} autoFocus={autoFocus} />
		</div>
	);
}

export function Segmented({ value, onChange, options, grow, style }) {
	return (
		<div className={cs('wsm-seg', { grow })} role="group" style={style}>
			{options.map((o) => (
				<button key={String(o.value)} type="button" className={cs({ on: o.value === value })} disabled={o.disabled} onClick={() => onChange(o.value)}>
					{o.icon ? <Icon name={o.icon} size={14} color={o.value === value ? COLORS.primary : COLORS.hint} /> : null}
					{o.label}
				</button>
			))}
		</div>
	);
}

export function Badge({ tone, small, children, style, title }) {
	return (
		<span className={cs('wsm-badge', tone, { sm: small })} style={style} title={title}>
			{children}
		</span>
	);
}

export function Tag({ color, children }) {
	return (
		<span className="wsm-tag">
			{color ? <i style={{ background: color }} /> : null}
			{children}
		</span>
	);
}

export function Stat({ label, value, sub, color, onClick, active }) {
	return (
		<div className={cs('wsm-stat', { click: !!onClick, active })} onClick={onClick} role={onClick ? 'button' : undefined}>
			<div className="wsm-stat-label">{label}</div>
			<div className="wsm-stat-value" style={color ? { color } : undefined}>
				{value}
			</div>
			{sub ? <div className="wsm-stat-sub">{sub}</div> : null}
		</div>
	);
}

// Tıklanabilir adım göstergesi. canGo(i) false dönen adımlar kilitli.
export function Stepper({ steps, current, onStep, canGo }) {
	return (
		<div className="wsm-stepper">
			{steps.map((s, i) => {
				const on = i <= current;
				const locked = canGo ? !canGo(i) : !onStep;
				return (
					<React.Fragment key={s}>
						<button type="button" className={cs('wsm-step', { on })} disabled={locked} onClick={() => onStep && onStep(i)}>
							<span className="wsm-step-num">{i < current ? <Icon name="check" size={14} color="#fff" strokeWidth={2.5} /> : i + 1}</span>
							{s}
						</button>
						{i < steps.length - 1 ? <span className={cs('wsm-step-line', { on: i < current })} /> : null}
					</React.Fragment>
				);
			})}
		</div>
	);
}

export function Banner({ tone, icon, children, style }) {
	const icons = { info: 'info', danger: 'alert', muted: 'info' };
	const colors = { info: COLORS.primary, danger: COLORS.danger, muted: COLORS.hint };
	return (
		<div className={cs('wsm-banner', tone)} style={style}>
			<Icon name={icon || icons[tone] || 'warn'} size={18} color={colors[tone] || COLORS.warn} />
			<div style={{ flex: 1, minWidth: 0 }}>{children}</div>
		</div>
	);
}

export function Empty({ icon = 'box', title, desc, action, compact }) {
	return (
		<div className={cs('wsm-empty', { compact })}>
			<div className="wsm-empty-icon">
				<Icon name={icon} size={24} color={COLORS.primary} />
			</div>
			<h3>{title}</h3>
			{desc ? <p>{desc}</p> : null}
			{action}
		</div>
	);
}

export function KV({ rows }) {
	return (
		<div className="wsm-kv">
			{rows.map((r, i) => (
				<div key={i}>
					<span>{r.label}</span>
					<strong style={r.color ? { color: r.color } : undefined}>{r.value}</strong>
				</div>
			))}
		</div>
	);
}

export function Pager({ page, pageSize, total, onChange, label }) {
	const pages = Math.max(1, Math.ceil(total / pageSize));
	const from = total ? (page - 1) * pageSize + 1 : 0;
	const to = Math.min(total, page * pageSize);
	return (
		<div className="wsm-pager">
			<span>
				{total ? `${num(from)}–${num(to)} / ` : ''}
				{label}
			</span>
			{pages > 1 ? (
				<div className="wsm-row" style={{ gap: 6 }}>
					<Btn variant="ghost" size="s" disabled={page <= 1} onClick={() => onChange(page - 1)}>
						Önceki
					</Btn>
					<span style={{ fontSize: 12 }}>
						{page} / {pages}
					</span>
					<Btn variant="ghost" size="s" disabled={page >= pages} onClick={() => onChange(page + 1)}>
						Sonraki
					</Btn>
				</div>
			) : null}
		</div>
	);
}

export function DeliveryBar({ total, sent, delivered, read, failed }) {
	const w = (n) => (total ? Math.max(0, (n / total) * 100) : 0).toFixed(1) + '%';
	return (
		<div className="wsm-bar" style={{ background: failed > 0 ? COLORS.bar.failed : undefined }} aria-hidden="true">
			<span style={{ width: w(read), background: COLORS.bar.read }} />
			<span style={{ width: w(Math.max(0, delivered - read)), background: COLORS.bar.delivered }} />
			<span style={{ width: w(Math.max(0, sent - delivered)), background: COLORS.bar.sent }} />
		</div>
	);
}

export function Progress({ pct, color }) {
	return (
		<div className="wsm-progress">
			<div style={{ width: Math.max(0, Math.min(100, pct || 0)) + '%', background: color || COLORS.primary }} />
		</div>
	);
}

// Modal: body'ye portal, ESC ile yalnızca en üstteki kapanır (sihirbaz içinde onay penceresi açılabiliyor).
let modalStack = [];
let modalSeq = 0;
export function Modal({ title, desc, icon = 'sparkles', width = 560, onClose, children, footer, footLeft, busy, bodyStyle, head }) {
	const [id] = useState(() => ++modalSeq);
	useEffect(() => {
		modalStack.push(id);
		return () => {
			modalStack = modalStack.filter((x) => x !== id);
		};
	}, [id]);
	useEffect(() => {
		const onKey = (e) => {
			if (e.key === 'Escape' && !busy && onClose && modalStack[modalStack.length - 1] === id) onClose();
		};
		window.addEventListener('keydown', onKey);
		return () => window.removeEventListener('keydown', onKey);
	}, [onClose, busy, id]);
	return ReactDOM.createPortal(
		<div className="wsm wsm-portal">
			<div className="wsm-overlay" onMouseDown={(e) => e.target === e.currentTarget && !busy && onClose && onClose()}>
				<div className="wsm-modal" role="dialog" aria-modal="true" style={{ maxWidth: width }}>
					<div className="wsm-modal-head">
						<div className="wsm-modal-icon">
							<Icon name={icon} size={18} color={COLORS.primary} />
						</div>
						<div style={{ flex: 1, minWidth: 0 }}>
							<div className="wsm-modal-title">{title}</div>
							{desc ? <div className="wsm-modal-desc">{desc}</div> : null}
							{head}
						</div>
						{onClose ? <IconBtn icon="x" title="Kapat" onClick={onClose} disabled={busy} /> : null}
					</div>
					<div className="wsm-modal-body" style={bodyStyle}>
						{children}
					</div>
					{footer ? (
						<div className="wsm-modal-foot">
							{footLeft ? <div className="wsm-foot-left">{footLeft}</div> : null}
							{footer}
						</div>
					) : null}
				</div>
			</div>
		</div>,
		document.body
	);
}

export function ConfirmModal({ title, desc, body, confirmText, cancelText, tone = 'danger', busy, onConfirm, onClose, icon = 'alert' }) {
	return (
		<Modal
			title={title}
			desc={desc}
			icon={icon}
			width={460}
			onClose={onClose}
			busy={busy}
			footer={
				<>
					<Btn variant="ghost" onClick={onClose} disabled={busy}>
						{cancelText || 'Vazgeç'}
					</Btn>
					<Btn variant={tone === 'danger' ? 'danger' : undefined} onClick={onConfirm} busy={busy}>
						{confirmText || 'Onayla'}
					</Btn>
				</>
			}
		>
			<div style={{ fontSize: 13, color: COLORS.slate, lineHeight: 1.6 }}>{body || 'Bu işlem geri alınamaz. Devam edilsin mi?'}</div>
		</Modal>
	);
}

// ── Bildirimler: notify(text, tone) her yerden çağrılabilir; <Toaster /> index'te bir kez durur ──
let toastListeners = [];
let toastId = 0;
export function notify(text, tone = 'ok') {
	const t = { id: ++toastId, text: String(text || ''), tone };
	toastListeners.forEach((fn) => fn(t));
}
export function Toaster() {
	const [items, setItems] = useState([]);
	useEffect(() => {
		const fn = (t) => {
			setItems((prev) => prev.concat(t));
			setTimeout(() => setItems((prev) => prev.filter((x) => x.id !== t.id)), t.tone === 'err' ? 7000 : 4500);
		};
		toastListeners.push(fn);
		return () => {
			toastListeners = toastListeners.filter((x) => x !== fn);
		};
	}, []);
	if (!items.length) return null;
	return ReactDOM.createPortal(
		<div className="wsm wsm-portal">
			<div className="wsm-toasts">
				{items.map((t) => (
					<div key={t.id} role="alert" className={cs('wsm-toast', t.tone)}>
						<Icon name={t.tone === 'err' ? 'alert' : t.tone === 'warn' ? 'warn' : 'check'} size={15} />
						<span>{t.text}</span>
					</div>
				))}
			</div>
		</div>,
		document.body
	);
}

// ── Yardımcılar ──
export function num(n) {
	return Number(n || 0).toLocaleString('tr-TR');
}
export function pct(n, total) {
	if (!total) return '—';
	return '%' + Math.round((n / total) * 100);
}
export function paginate(list, page, size) {
	return (list || []).slice((page - 1) * size, page * size);
}
export function searchMatch(q, ...fields) {
	if (!q) return true;
	const needle = q.toLocaleLowerCase('tr').trim();
	const digits = needle.replace(/\D/g, '');
	return _.some(fields, (f) => {
		if (f === undefined || f === null) return false;
		const s = String(f);
		return s.toLocaleLowerCase('tr').includes(needle) || (digits.length >= 3 && s.replace(/\D/g, '').includes(digits));
	});
}
export function phoneOf(id) {
	return String(id || '')
		.replace(/@.*/, '')
		.replace(/\s+/g, '');
}

// log servisi üzerinden excel indirme (sheets: [{ name, x: kolonlar, datasets }])
export function downloadSheets(filename, sheets) {
	return fetch('https://log.yapaytech.com/analytic/download', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ filename, sheets }),
	})
		.then((r) => r.json())
		.then((data) => {
			if (!data || !data.url) throw new Error('Excel oluşturulamadı.');
			const a = document.createElement('a');
			a.href = data.url;
			a.setAttribute('download', data.url);
			a.click();
		});
}

// localStorage erişimi gizli pencerede atabilir
export function readPref(key, def) {
	try {
		const v = window.localStorage.getItem(key);
		return v === null ? def : v;
	} catch (e) {
		return def;
	}
}
export function writePref(key, value) {
	try {
		window.localStorage.setItem(key, value);
	} catch (e) {
		/* yok say */
	}
}
